import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { api, ErrorResponse } from "@/utils/api";

export const useRemoveChannel = (
  projectId: string,
  channelId: string,
  options: Omit<UseMutationOptions<void, ErrorResponse, void, unknown>, "mutationFn"> = {},
) => {
  const queryClient = useQueryClient();

  return useMutation<void, ErrorResponse, void, unknown>({
    mutationFn: async (): Promise<void> => {
      await api.delete(`/projects/${projectId}/channels/${channelId}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "channels"],
      });
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "channels", channelId],
      });
    },
    ...options
  });
};
